import Main from './components/Main.vue'

import iCal from './components/providers/iCal.vue'

import InForms from './components/providers/in_forms/Main.vue'
import InFormsForm from './components/providers/in_forms/Form.vue'

import Zapier from './components/providers/Zapier.vue'

import FacebookLeads from './components/providers/facebook_leads/Main.vue'

import FacebookLeadsForm from './components/providers/facebook_leads/Form.vue'

import MailTrap from './components/providers/MailTrap.vue'

import RdStation from './components/providers/rd_station/Main.vue'

export default [
    {
        name: 'integrations.index',
        path: '/integrations',
        component: Main,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'integrations.providers.ical',
        path: '/integrations/ical',
        component: iCal,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'integrations.providers.mail-trap',
        path: '/integrations/mail-trap',
        component: MailTrap,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'integrations.informs.index',
        path: '/integrations/in-forms',
        component: InForms,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                name: 'integrations.informs.create',
                path: '/integrations/in-forms/create',
                component: InFormsForm,
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'integrations.informs.edit',
                path: '/integrations/in-forms/:id/edit',
                component: InFormsForm,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        name: 'integrations.zapier.index',
        path: '/integrations/zapier',
        component: Zapier,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'integrations.facebook-leads.index',
        path: '/integrations/facebook-leads',
        component: FacebookLeads,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                name: 'integrations.facebook-leads.create',
                path: '/integrations/facebook-leads/create',
                component: FacebookLeadsForm,
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'integrations.facebook-leads.edit',
                path: '/integrations/facebook-leads/:id/edit',
                component: FacebookLeadsForm,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        name: 'integrations.rd-station.index',
        path: '/integrations/rd-station',
        component: RdStation,
        meta: {
            requiresAuth: true
        }
    }
]



// WEBPACK FOOTER //
// ./src/modules/integrations/routes.js